import React,{ useState, useEffect } from 'react';
import { Paper, Grid, Typography, Fade, Box } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import placeholderImage from "../../../images/placeholderImage.jpg";
import PDFViewer from "./PDFViewer"
import DocumentGrid from "./DocumentGrid";
import useStyles from './Styles/StagingStyles';
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import notify from "../../../utils/notifier";
import DocumentTabularView from "../DocumentTabularView";
import PaginationRoot from "../PaginationRoot";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';




export const Staging = ({viewType, currentCompany}) => {

    const classes = useStyles();
    const [documents, setDocuments] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);

    const [queryCount, setQueryCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('created_at');
    const [selectedDocuments, setSelectedDocuments] = useState(new Map());
    const [backdrop, setBackdrop] = useState(false);
    const [clientFields, setClientFields] = useState([]);
    const [selectedDocumentsFileId, setSelectedDocumentsFileId] = useState(new Set());
    const [types, setTypes] = useState([]);
    const [isWorkflowEnabled, setIsWorkflowEnabled] = useState(false);



    const handleDocumentClick = (doc) => {
        setSelectedDoc((prevSelectedId) => (doc));
    };

    const handleSelectedDocs = (id, checked, fileIdentifier = null, name = null)  => {
        setSelectedDocuments(prev => {
            const newMap = new Map(prev);
            if (checked) {
              newMap.set(id, name || id);
            } else {
              newMap.delete(id);
            }
            return newMap;
          });

        if (fileIdentifier){
            setSelectedDocumentsFileId(prev => {
                const newSet = new Set(prev); 
                if (checked) {
                newSet.add(fileIdentifier);
                } else {
                newSet.delete(fileIdentifier); 
                }
                return newSet;
            });
        }
        
        
    }

    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
        setPage(0);
        fetchDocuments(rowsPerPage, 0, property, isDesc ? "asc" : "desc");
    };

    const handleFilterSearch = filters => {
        setPage(0);
        setSelectedDoc(null);
        fetchDocuments(rowsPerPage, 0, orderBy, order, filters);
    };

    const fetchDocuments = (
        pageSize = rowsPerPage,
        currentPage = 0,
        sortBy = orderBy,
        sortOrder = order,
        filters = {}
    ) => {
    
        setBackdrop(true);
        setSelectedDocuments(new Set());
        setSelectedDocumentsFileId(new Set());
    
        const executeSearch = (workflowEnabled) => {
    
            let requestObj = {};
    
            if (workflowEnabled) {
                requestObj.stagingReasons = [
                    "malicious",
                    "duplicate_content",
                    "same_file_name",
                    "folder_conflict",
                    "poor_indexing",
                    "poor_classification",
                    "pending_categorization"
                ];
            }
    
            let queryParams = {
                '_page': currentPage + 1,
                '_limit': pageSize,
                '_documentType' : 'other'
            };
    
            if (sortBy && sortOrder) {
                queryParams['_sort'] = sortBy;
                queryParams['_order'] = sortOrder;
            }
    
            if (filters) {
                queryParams = { ...queryParams, ...filters };
            }
    
            DocuwareTemplateService.searchDocuments(requestObj, queryParams).then(response => {
                let searchDocumentsResponse = response.data;
                let totalCount = response.headers['x-total-count'];
                let sampleDocuments = searchDocumentsResponse;
    
                setDocuments(sampleDocuments);
                setSelectedDocuments(new Set());
                setSelectedDocumentsFileId(new Set());
                setQueryCount(totalCount);
                setBackdrop(false);
            }).catch(error => {
                notify({
                  type: 'error',
                  message: 'Error getting the staging documents'
                });
                setBackdrop(false);
            });
        };
    
        // If templates not loaded yet
        if (types.length === 0) {
    
            DocuwareTemplateService.getAllTemplates(null)
                .then(response => {
                    const templateResponse = response.data;
    
                    let workflowEnabled = false;
    
                    if (templateResponse?.hasOwnProperty('isWorkflowEnabled')) {
                        workflowEnabled = templateResponse.isWorkflowEnabled;
                        setIsWorkflowEnabled(workflowEnabled);
                    }
    
                    const docTypes = templateResponse?.documentTypes || [];
                    const filteredTypes = docTypes
                        .filter(template => template.name !== 'other')
                        .map(template => template.name);
    
                    setTypes(filteredTypes);
    
                    executeSearch(workflowEnabled);
                })
                .catch(() => {
                    notify({
                        type: 'error',
                        message: 'Error fetching the document types'
                    });
                    setBackdrop(false);
                });
    
        } else {
            // Templates already loaded
            executeSearch(isWorkflowEnabled);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchDocuments(rowsPerPage, newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        fetchDocuments(+event.target.value, 0);
    };

    const fetchClientFields = ()=>{
        DocuwareTemplateService.getClientFields().then(response => {
            let clientFieldResponse = response.data;
            // Filter out alias fields (fields with parentFieldId) - only show canonical fields
            clientFieldResponse = clientFieldResponse.filter(field => 
              !field.parentFieldId && !field.parent_field_id
            );
            setClientFields(clientFieldResponse);
          }).catch(error => {
            notify({
              type: 'error',
              message: 'Error fetching the field columns'
            });
        })

        DocuwareTemplateService.getAllTemplates(null).then(response => {
            let templateResponse = response.data;
            // Check if response has new structure with isWorkflowEnabled
            if (templateResponse && templateResponse.hasOwnProperty('isWorkflowEnabled')) {
                setIsWorkflowEnabled(templateResponse.isWorkflowEnabled);
            }
            const docTypes = templateResponse ? templateResponse.documentTypes : [];
            const filteredTypes = docTypes.filter(template => template.name !== 'other').map(template => (template.name));
            setTypes(filteredTypes);
        }).catch(error => {
            notify({
                type: 'error',
                message: 'Error fetching the document types'
            });
        });
    }

    useEffect(() => {
        
        fetchClientFields();
    }, [currentCompany]);

    return (
        <div style={{ maxWidth: '90vw', overflowX: 'hidden' }}>
            <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid container spacing={3} style={{ marginTop: 2, height: 'calc(100vh - 130px)' }}>
                {/* Document Grid */}
                <Grid item xs={12} md={(selectedDoc && selectedDocuments && selectedDocuments.size<=1) ? 6 : 12} style={{ height: '100%' }}>
                    <Fade in timeout={500}>
                        <Paper
                            style={{
                                height: '100%',
                                overflow: 'auto',
                                padding: 28,
                                boxSizing: 'border-box',
                                background: viewType!='grid' ?"#ffffff" : "#f8f8f8"
                            }}
                        >
                            {viewType==='grid' ? 
                            <div>
                            <Grid
                            container
                            spacing={3}              
                            justifyContent="flex-start"
                            alignItems="stretch"
                            >
                                <DocumentGrid
                                documents={documents}
                                placeholderImage={placeholderImage}
                                onDocumentClick={handleDocumentClick}
                                selectedDoc={selectedDoc}
                                />
                            </Grid>
                            <PaginationRoot
                            queryCount={queryCount}
                            page={page}
                            handleChangePage={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}/>
                            </div>
                            :
                                        
                            <DocumentTabularView 
                                rows={documents}
                                onDocumentClick={handleDocumentClick}
                                orderBy = {orderBy}
                                order = {order}
                                queryCount={queryCount}
                                page={page}
                                handleChangePage={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                                handleMultipleFileSelect={handleSelectedDocs}
                                selectedDocuments={selectedDocuments}
                                selectedDocumentsFileId={selectedDocumentsFileId}
                                setBackdrop = {setBackdrop}
                                clientFields = {clientFields}
                                handleRequestSort={handleRequestSort}
                                handleFilterSearch = {handleFilterSearch}
                                documentTypes={['other']}
                                currentCompany={currentCompany}
                                allDocumentTypes={types}
                                isStaging={true}
                                showStagingCause={isWorkflowEnabled}
                            />}
                        </Paper>
                    </Fade>
                </Grid>

                {/* PDF Viewer */}
                {(selectedDoc && selectedDocuments && selectedDocuments.size<=1) && (
                    <Grid item xs={12} md={6} style={{ height: '100%' }}>
                        <Paper
                            elevation={3}
                            style={{ height: '100%', padding: 16, overflow: 'auto', background: "#f8f8f8" }}
                        >
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={2} // margin bottom
                            >
                                <Typography variant="h6" noWrap>
                                    {documents.find((doc) => doc.id === selectedDoc)?.name}
                                </Typography>
                                <IconButton onClick={() => setSelectedDoc(null)}>
                                <CloseIcon />
                                </IconButton>
                            </Box>
                            <Fade in timeout={500}>   
                                <div
                                    style={{
                                        height: '100%',
                                        overflow: 'auto',
                                        padding: 8,
                                        background: '#f5f5f5',
                                        borderRadius: 4,
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <PDFViewer file={selectedDoc.id} name={selectedDoc.name} extension={selectedDoc.extension}/>
                                </div>
                            </Fade>
                        </Paper>
                    </Grid>
                )}
             </Grid>
        </div>
      );
}